import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import SearchResults from "@/pages/SearchResults";
import ProductPage from "@/pages/ProductPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrdersPage from "@/pages/OrdersPage";
import OrderDetailPage from "@/pages/OrderDetailPage";
import AuthPage from "@/pages/AuthPage";
import SellerRegisterPage from "@/pages/SellerRegisterPage";
import SellerPortal from "@/pages/SellerPortal";
import AdminPortal from "@/pages/AdminPortal";
import WishlistPage from "@/pages/WishlistPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import VendorStorefrontPage from "@/pages/VendorStorefrontPage";

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="max-w-7xl mx-auto px-8 mt-12"><div className="h-64 rounded-2xl bg-slate-100 animate-pulse" /></div>;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return children;
}

function App() {
  const isAdminHost = window.location.hostname.split(".")[0] === "admin";
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Routes>
              {isAdminHost ? (
                <>
                  <Route path="/admin/login" element={<AuthPage mode="login" portal="admin" />} />
                  <Route path="/admin" element={<AdminPortal />} />
                  <Route path="*" element={<Navigate to="/admin/login" replace />} />
                </>
              ) : (
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/search" element={<SearchResults />} />
                <Route path="/product/:id" element={<ProductPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:id" element={<BlogPostPage />} />
                <Route path="/store/:sellerId" element={<VendorStorefrontPage />} />
                <Route path="/login" element={<AuthPage mode="login" portal="customer" />} />
                <Route path="/vendor/login" element={<AuthPage mode="login" portal="vendor" />} />
                <Route path="/admin/login" element={<AuthPage mode="login" portal="admin" />} />
                <Route path="/register" element={<AuthPage mode="register" />} />
                <Route path="/sell" element={<SellerRegisterPage />} />
                <Route path="/cart" element={<RequireAuth><CartPage /></RequireAuth>} />
                <Route path="/checkout" element={<RequireAuth><CheckoutPage /></RequireAuth>} />
                <Route path="/orders" element={<RequireAuth><OrdersPage /></RequireAuth>} />
                <Route path="/orders/:id" element={<RequireAuth><OrderDetailPage /></RequireAuth>} />
                <Route path="/wishlist" element={<RequireAuth><WishlistPage /></RequireAuth>} />
                <Route path="/seller" element={<SellerPortal />} />
                <Route path="/admin" element={<AdminPortal />} />
              </Route>
              )}
            </Routes>
            <Toaster position="bottom-right" richColors />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
